export enum TiposAditivoContratoEnum {
    ADITIVO = 1,
    RERRATIFICACAO = 2,
    APOSTILAMENTO = 3,
    ALTERACAO_SUBJETIVA = 4
  }